import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import get from 'lodash.get';
import { buildUrlWithParams } from '../helpers/utility';

class Cta extends React.Component {
	componentDidMount() {
		// required to make the cta button work on mobile
		const ddcSlideIn = get(window, 'DDC.mobile.slidein', undefined);
		if (this.props.transparent && ddcSlideIn) {
			ddcSlideIn.init();
		}
	}

	trackEvent() {
		this.props.trackGa({
			element: 'Share button',
			result: 'Opened share modal',
			widgetState: 'default'
		});
	}

	render() {
		const {
			href,
			icon,
			label,
			params,
			dialog,
			dialogTitle,
			transparent
		} = this.props;

		const url = buildUrlWithParams(href, params);

		const dataAttributes = {
			'data-href': url,
			href: url
		};

		const ctaClassArray = ['cta'];
		if (!transparent) {
			ctaClassArray.push('mr-4');
		}

		const buttonClassArray = [
			'align-items-center',
			'd-flex',
			'btn-share',
			'btn-no-decoration',
			'btn-small'
		];
		if (dialog) {
			buttonClassArray.push('dialog');
		}
		if (transparent) {
			buttonClassArray.push('px-3 py-4');
		}

		return (
			<Common
				render={({ labels }) => {
					if (dialog) {
						// On mobile if you omit data-title the slidein does not work.
						// We provide a backup in case the dialogTitle preference is blank.
						const labelAlias =
							dialogTitle === '' ? label : dialogTitle;
						dataAttributes['data-title'] = labels.get(labelAlias);
						dataAttributes.rel = 'nofollow';
					}

					return (
						<div className={ctaClassArray.join(' ')}>
							<Button
								className={buttonClassArray.join(' ')}
								bsStyle={transparent ? 'link' : 'default'}
								onClick={() => {
									this.trackEvent();
								}}
								{...dataAttributes}
							>
								{icon}
								<span
									className={`pl-1${
										transparent ? ' sr-only' : ''
									}`}
								>
									{labels.get(label)}
								</span>
							</Button>
						</div>
					);
				}}
			/>
		);
	}
}

Cta.propTypes = {
	href: PropTypes.string.isRequired,
	icon: PropTypes.element,
	label: PropTypes.string.isRequired,
	params: PropTypes.shape({}),
	dialog: PropTypes.bool.isRequired,
	dialogTitle: PropTypes.string,
	transparent: PropTypes.bool.isRequired,
	trackGa: PropTypes.func.isRequired
};

Cta.defaultProps = {
	params: {},
	dialogTitle: '',
	icon: <svg />
};

export default Cta;



// WEBPACK FOOTER //
// ./src/components/Cta.jsx